<template>
  <nav id="main_nav" :class="mainNavClass" @click="mainNavClass = ''">
    <div class="outer-wrapper">
      <div class="wrapper" v-if="pages">
        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="`/biogramy`"
          ><span>Biogramy</span></router-link
        >
        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="{
            name: 'Documents',
            params: { itemType: 'FizykotekaDokument' },
          }"
          ><span>Dokumenty</span></router-link
        >

        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="`/eksponaty`"
          ><span>Eksponaty</span></router-link
        >

        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="{ name: 'Photos', params: { itemType: 'FizykotekaFotografia' } }"
          ><span>Fotografie</span></router-link
        >

        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="`/nagrania`"
          ><span>Nagrania</span></router-link
        >

        <div class="menu-space"></div>

        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="`/kolekcje`"
          ><span>Kolekcje</span></router-link
        >
        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="`/wystawy`"
          ><span>Wystawy</span></router-link
        >

        <router-link
          @mouseover.native="hover = true"
          @mouseleave.native="hover = false"
          :to="`/etykiety`"
          ><span>Etykiety</span></router-link
        >

        <div class="menu-space"></div>

        <div v-for="(page,index) in pages" :key="index">
          <router-link
            @mouseover.native="hover = true"
            @mouseleave.native="hover = false"
            :to="`/strona/` + page.slug"
            ><span v-html="page.title"></span></router-link
          >
          <div class="menu-space"></div>  
        </div>


        <svg id="hover-box" preserveAspectRatio="none">
          <rect x="0" y="0" width="100%" height="55" />
        </svg>
      </div>
      <svg id="close" viewBox="0 0 512 512">
        <line x1="0" y1="0" x2="512" y2="512" />
        <line x1="0" y1="512" x2="512" y2="0" />
      </svg>
    </div>
    <svg id="box" preserveAspectRatio="none">
      <line x1="0" y1="0" x2="100%" y2="0" />
      <line x1="100%" y1="100%" x2="0" y2="100%" />
      <line x1="100%" y1="100%" x2="100%" y2="0" />
      <line x1="0" y1="0" x2="0" y2="100%" />
    </svg>
  </nav>
</template>
<script>
import Vivus from "vivus";
import { eventBus } from "@/main.js";

import axios from "axios";

export default {
  name: "Navigation",
  data: () => ({
    msg: "Welcome to Your Vue.js App",
    mainNavClass: "",
    pages: [],
    key: Math.random(),
    hover: null,
  }),
  methods: {
    fetchData: function () {
      axios.get(this.$config.API_PATH + "simple_pages").then((_resp) => {
        let _pages = [];

        _resp.data.forEach((_p) => {
          let _page = {
            title: _p.title,
            slug: _p.slug,
            id: _p.id,
          };
          // pls exclude page 7
          if (_p.id != 7) _pages.push(_page);
        });
        this.pages = _pages;
      });
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    hover: function () {
      // https://forum.vuejs.org/t/router-link-tag-and-mouseover-event/923

      if (window.innerWidth > 768) {
        if (this.hover == true) {
          $("#main_nav a").on("mouseover", function (e) {
            var w = $(this).children().width();
            var t = $(this).offset().top - parseInt($("#main_nav").css("top"));

            $("#hover-box")
              .width(w + 13)
              .css("top", t + "px")
              .fadeIn(200);
          });
        } else {
          $("#main_nav .wrapper").on("mouseleave", function (e) {
            $("#hover-box").fadeOut(200);
          });
        }
      }
    },
  },
  created() {
    eventBus.$on("isMenuActive", (data) => {
      this.mainNavClass = "active";
    });
  },
};
</script>

<style scoped>
.menu-space {
  height: 5px;
  margin-top: 1em;
  margin-bottom: 1em;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/Navigation.vue